module.exports = __webpack_public_path__ + "static/mr-press-34-439891a485d05ca4a21494bd585ca85e.jpg";